import { render, staticRenderFns } from "./AddIntergration.vue?vue&type=template&id=2f2d7c36&"
import script from "./AddIntergration.vue?vue&type=script&lang=js&"
export * from "./AddIntergration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports